<template>
    <div class="tw-max-w-screen-2xl tw-mx-auto tw-w-full tw-p-2 tw-pt-0 tw-flex tw-items-center tw-justify-center">
        
        <div class="tw-flex tw-items-center tw-gap-2">
            <div v-for="link in links" :key="link.key">
                <router-link 
                :to="link.route"
                :class="{'!tw-text-primary-600 tw-font-semibold': link.route.name == $route.name}"
                class="tw-p-2 tw-text-primary-950 hover:tw-text-primary-600 tw-duration-200"
                >{{ $t(link.name) }}</router-link>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useAuthStore } from '@/stores/auth';
import { getFilteredNavigationLinks } from '@/config/navigation';

const authStore = useAuthStore();
const user = computed(() => authStore.user);

// Filtered links based on user role
const links = computed(() => {
    return getFilteredNavigationLinks(user.value?.role);
});
</script>

